import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import { theme } from '_constants/theme';

import Paginate from 'components/shared/Paginate';
import Text from 'components/shared/layouts/Text';

import PaymentMethodCard from './PaymentMethodCard';

const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.spaces.regular}px;
`;
const PaymentMethodsList = ({ loading, items, pageCount, currentPage, onPageChange }) => {
  return (
    <StyledContainer>
      {items?.map((item) => (
        <PaymentMethodCard key={item?.orderId} {...item} />
      ))}
      {!loading && !items?.length && <Text centered>No payment methods found</Text>}
      <Paginate pageRangeDisplayed={3} pageCount={pageCount} currentPage={currentPage} onPageChange={onPageChange} />
    </StyledContainer>
  );
};

PaymentMethodsList.propTypes = {
  loading: PropTypes.bool,
  items: PropTypes.array,
  pageCount: PropTypes.number,
  currentPage: PropTypes.number,
  onPageChange: PropTypes.func,
};

export default PaymentMethodsList;
